import { IconButton, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../context/languageContext";

function ChangeLanguage() {
  const { i18n } = useTranslation();
  const { currentLanguage, setCurrentLanguage } = useLanguage();

  const handleChangeLanguage = (event: SelectChangeEvent<string>) => {
    const language = event.target.value;
    setCurrentLanguage(language);
  };

  return (
    <IconButton
      size="large"
      edge="end"
      aria-label="account of current user"
      aria-haspopup="true"
      color="inherit"
      sx={{ p: 1 }}
    >
      <Select
        native
        value={currentLanguage}
        onChange={handleChangeLanguage}
        sx={{
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 1 },
          color: "#fff",
        }}
        inputProps={{
          style: {
            padding: "14px 14px" ,
            marginRight:"20px"
          },
        }}
      >
        <option style={{ color: "black" }} value="es">
          Español
        </option>
        <option style={{ color: "black" }} value="en">
          English
        </option>
      </Select>
    </IconButton>
  );
}

export default ChangeLanguage;
